import BasicContentShareTray from './BasicContentShareTray';

export { type BasicContentShareTrayProps } from './BasicContentShareTray';
export default BasicContentShareTray;
